<!--
 *                   ___====-_  _-====___
 *             _--^^^#####//      \\#####^^^--_
 *          _-^##########// (    ) \\##########^-_
 *         -############//  |\^^/|  \\############-
 *       _/############//   (@::@)   \############\_
 *      /#############((     \\//     ))#############\
 *     -###############\\    (oo)    //###############-
 *    -#################\\  / VV \  //#################-
 *   -###################\\/      \//###################-
 *  _#/|##########/\######(   /\   )######/\##########|\#_
 *  |/ |#/\#/\#/\/  \#/\##\  |  |  /##/\#/  \/\#/\#/\#| \|
 *  `  |/  V  V  `   V  \#\| |  | |/#/  V   '  V  V  \|  '
 *     `   `  `      `   / | |  | | \   '      '  '   '
 *                      (  | |  | |  )
 *                     __\ | |  | | /__
 *                    (vvv(VVV)(VVV)vvv)
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                神兽保佑            永无BUG
 -->



<template>
  <div class="organization">
    <!-- 顶部选择 -->
    <div class="organization-top">
      <div class="organization-top-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="68px" size="mini">
          <el-form-item>
            <el-input prefix-icon="el-icon-search" v-model="formInline.keyword" placeholder="请输入要搜索的内容" clearable> </el-input>
          </el-form-item>
          <el-form-item label="标准科室">
            <el-cascader
            placeholder="选择或者搜索"
            v-model="formInline.standardDepartmentId"
            :props="setKesDept"
            :options="departmentList"
            filterable
            clearable
          >
          </el-cascader>
          </el-form-item>
          <el-form-item label="科室状态">
            <el-select v-model="formInline.disabled" placeholder="请选择科室状态" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="启用" value="fasle"></el-option>
              <el-option label="禁用" value="true"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改时间" clearable>
            <el-date-picker align="center" size="mini" v-model="formInline.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
          </el-form-item>
        </el-form>
        <el-form inline>
          <el-form-item label="归属医院">
           <el-radio-group v-model="radio" @change='radioChange'>
              <el-radio label="platform">互医平台</el-radio>
              <el-radio label="open">实体医院</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-select size="mini" v-model="formInline.hospitalId" placeholder="请选择归属医院" clearable>
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in commonHospitalList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" size="mini" @click="resetHandel">重置</el-button>
              <el-button type="primary" size="mini" @click="queryHandel">搜索</el-button>
          </el-form-item>
          <el-form-item>

          <!-- 
            TODO 参数4个，第一个为新增科室的父id，第二个是添加同级和下级，第三个是当前选中的row🈯值，第4个为禁用归属医院
           -->
              <el-button type="primary" size="mini" :disabled="parentDisabledBtn" @click="addDept(0, 1, ChangeScopeItem,1)">新增一级科室</el-button>
              <el-button type="primary" size="mini" :disabled="disabledBtn" @click="addDept(ChangeScopeItem.parentId, 1, ChangeScopeItem,2)">新增同级科室</el-button>
              <el-button type="primary" size="mini" :disabled="disabledBtn" @click="addDept(ChangeScopeItem.id, 2, ChangeScopeItem,3)">新增下级科室 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 内容 -->
    <base-table
      class="tablessp"
      border
      ref="multipleTable"
      :data="tableData"
      :column="columnsConfig"
      :default-expand-all="false"
      @select="handleSelect" 
      @selection-change="handleSelectionChange" 
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
    </base-table>
    <div class="organization-content">

    </div>

     <el-dialog
      :visible.sync="drawer"
      :width="width"
      center
      :fullscreen="false"
      modal
      :close-on-click-modal="false"
      :show-close="true"
      :destroy-on-close="true"
      :top="top"
    >
    <slot name="title" class="dialog-footer">
      <div class="slot-footer">
        <h1 class="title">科室信息</h1>
        <el-button
          type="text"
          size="mini"
          class="btn"
          @click="edit = !edit"
          >{{ edit ? "编辑" : "只读" }}</el-button
        >
      </div>
    </slot>
    
     <el-form :model="editsonlist" inline ref="editlist" label-width="100px" class="demo-ruleForm" size="medium" :rules="rules">
          <el-form-item label="科室名称：" prop="name">
            <el-input v-model="editsonlist.name" :disabled="edit"></el-input>
          </el-form-item>
          <el-form-item label="归属医院：">
            <el-select v-model="editsonlist.hospitalId" placeholder="请选择医院" disabled>
              <el-option v-for="item in commonHospitalList" :key="item.id" :label="item.name || '未知'" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标准科室：">
            <el-cascader
              placeholder="选择或者搜索"
              :disabled="edit"
              v-model="editsonlist.standardDepartmentId"
              :props="setKesDept"
              :options="departmentList"
              filterable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="节点类型：">
            <span>{{ editsonlist.parentId ? '分支节点' : '根节点' }}</span>
          </el-form-item>
         
          <el-form-item label="科室简介：" prop="description">
            <el-input type="textarea" v-model="editsonlist.description" :disabled="edit"></el-input>
          </el-form-item>
         
          <div class="footer">
            <p>
              <span>创建人:</span>
              <span>{{editsonlist.createUserId}}</span>
            </p>
            <p>
              <span>创建时间:</span>
              <span>{{editsonlist.createTime}}</span>
            </p>
            <p>
              <span>最后更新:</span>
              <span>{{editsonlist.updateUserId}}</span>
            </p>
            <p>
              <span>更新时间:</span>
              <span>{{editsonlist.updateTime}}</span>
            </p>
          </div>
        </el-form>
    
     <span slot="footer" class="dialog-footer">
        <el-button @click="drawer = false">取 消</el-button>
        <el-button type="primary" @click="sonedit" >确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新建开放科室 -->
    <el-dialog title="创建科室" :visible.sync="isShowAdd" width="40%" :destroy-on-close="true" @close="closeDiaolg" v-if="isShowAdd">
      <!--  flag = false,flagcopy=false -->
      <el-form :model="createForm" label-width="100px" :rules="rules" ref="createForm" size="mini">

        <el-form-item label="科室名称" v-if="flag">
          <p>{{ childrenData.name }}</p>
        </el-form-item>

        <el-form-item :label="flag ? '下级科室' : '科室名称'" prop="name">
          <el-input v-model="createForm.name"></el-input>
        </el-form-item>
        
        <el-form-item label="归属医院：" prop="hospitalId">
          <el-select v-model="createForm.hospitalId" placeholder="请选择医院" :disabled="flag || flagcopy">
            <el-option v-for="item in commonHospitalList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="归属医院：" prop="hospitalId" v-else>
          <el-select v-model="createForm.hospitalId" placeholder="请选择医院">
            <el-option v-for="item in commonHospitalList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="标准科室：" prop="standardDepartmentId">
          <el-cascader
            placeholder="选择或者搜索"
            v-model="createForm.standardDepartmentId"
            :props="setKesDept"
            :options="departmentList"
            filterable
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="科室简介：" prop="description">
          <el-input type="textarea" v-model="createForm.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="foot" style="text-align: center;">
        <el-button type="primary" @click="confirmAdd('createForm')" size="medium">完成</el-button>
        <el-button @click="cancelAdd" size="medium">退出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DepartConfig from './conmon/departConfig'
import axios from 'axios'
import { getdepartment, postDepartment, getDepartmentDetail, deleteDepartment, getHospital, getStandard ,getPlatformList ,moveDown , moveUp} from './api'
import _ from 'lodash'
export default {
  mixins: [DepartConfig],
  data() {
    return {
      //弹窗参数
      width: "80%",
      top: "5vh",
      height: "50vh",
      edit:true,
      ChangeScopeItem:'',//选中科室的参数
      flag: false, //用于区分是同级科室还是 子集科室
      flagcopy:false,
      radio:'platform',//
      childrenData: '', //存储子集数据
      commonHospitalList:[],//实体医院和归宿医院和公共容器
      platformList:[],//互译平台
      setKesDept: {
        value: "id",
        label: "name",
        emitPath:false
      },
      formInline: {
        keyword: '',
        hospitalId: '', //所属医院
        standardDepartmentId: '', //标准科室状态
        disabled: '', //科室状态
        time: [],
        updateEndTime: '',
        updateStartTime: '',
      },
      hospitalsList: [], // 医院列表
      departmentList: [], // 科室列表
      tableData: [], // 树形数据
      editsonlist: {}, // 科室信息弹出框数据
      drawer: false, // 科室信息弹出框
      isShowDept: false, // 标准科室弹出框
      currentItemId: 0, // 创建基准
      isShowAdd: false, // 创建弹出层
      createForm: {
        name: '',
        description: '',
        hospitalId: '',
        platformId:'',//切换互医平台的时候需要用到这个id
        standardDepartmentId: '',
        // cityList:[],
      },
      rules: {
        name: [
          { required: true, message: '请输入科室名称', trigger: 'blur' },
          {
            min: 1,
            max: 15,
            message: '长度在 1 到 15 个字符',
            trigger: 'blur',
          },
        ],
        hospitalId: [{ required: true, message: '请选择归属医院', trigger: 'change' }],
        standardDepartmentId:[{ required: true, message: '请选择标准科室', trigger: 'change' }],
        description: [
          { required: true, message: '请填写科室简介', trigger: 'blur' },
          {
            min: 5,
            max: 200,
            message: '长度在 5 到 200 个字符',
            trigger: 'blur',
          },
        ],
      },
      //TODO 切换医院平台 互医和实体 该页面的接口全部需要替换掉，默认为互医平台 参数platform open为实体平台
      paramsType:'platform',//默认为互译open
    }
  },
  created() {
    if(this.$route.query.id){
      this.formInline.hospitalId = this.$route.query.id;
      this.formInline.platformId = this.$route.query.id;
    }
    
    this.getPlatformListInit();
    this.getHospitalInit();
    this.getStandardHandel()
// getdepartment
    if(this.$route.query.type  == 'platform'){
      this.radio = 'platform'
    }else if(this.$route.query.type  == 'open'){ 
      this.radio = 'open';
      getHospital().then((res) => {
        if (res.code == 0) {
          this.commonHospitalList = res.data
        }
      })
      this.commonHospitalList = this.platformList
    }
    this.init(this.paramsType = this.radio == 'platform' ? 'platform' :'open')
  },
  computed:{
    disabledBtn(){
      //选中科室后新增按钮才会生效 新增一级科室除外
      return this.ChangeScopeItem ? false : true
    },
    parentDisabledBtn(){
      //选中科室后并且parentId为 0 的时候新增一级科室按钮才会生效
      return !this.tableData.length || (this.ChangeScopeItem && this.ChangeScopeItem.parentId == 0) ? false : true
    }
  },
  methods: {
    /**
     * @description: 
     * @param {*}
     * @return {*}
     */
    goPath(scope){
      if(scope.platformId){
        this.$router.push({path:'/Organization/medicalteam',query:{id:scope.id,platformId:scope.platformId}})
      }else{
        this.$router.push({path:'/Organization/medicalinfo',query:{id:scope.hospitalId}})
      }
    },
    /**
     * @description: 
     * @param {*}
     * @return {*}
     */
    closeDiaolg(){
      this.flag = false;
      this.flagcopy=false;
      this.isShowAdd = false
    },
    /**
     * @description: 获取标准科室列表
     * @param {*}
     * @return {*}
     */
    getStandardHandel(){
      getStandard().then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data
        }
      })
    },
    /**
     * @description: 获取互医平台医院
     * @param {*}
     * @return {*}
     */
    getPlatformListInit(){
      getPlatformList().then(res=>{
        if(res.code == 0){
          this.platformList = res.data;
          // .map(item=>{
          //   item.isPlatform = true
          //   return item
          // })
          this.commonHospitalList = this.platformList

        }
      })
    },
    /**
     * @description: 获取医院列表
     * @param {*}
     * @return {*}
     */
    getHospitalInit(){
      getHospital().then((res) => {
        if (res.code == 0) {
          this.hospitalsList = res.data
        }
      })
    },
    
    /**
     * @description: 切换归属医院替换相应的信息
     * @param {*}
     * @return {*}
     */
    radioChange(e){
      this.paramsType = e;
      this.formInline = this.$options.data().formInline
      if(e == 'open') this.commonHospitalList = this.hospitalsList
      else this.commonHospitalList = this.platformList
      this.init(this.paramsType)
    },
    /**
     * @description: 勾选的时候来判断 让其变成单选
     * @param {*} val
     * @param {*} row
     * @return {*}
     */
    handleSelect(val,row){
      if (val.length > 1) {
        this.$refs.multipleTable.$refs.elTable.clearSelection() // 清空所有选择
        val.shift()
        this.$refs.multipleTable.$refs.elTable.toggleRowSelection(row)//  选中当前选择
      }
    },
    handleSelectionChange(val){
      if(val.length){
        let posy = val
        posy.forEach(item=>{
          this.ChangeScopeItem = item
        })
      }else{
        this.ChangeScopeItem = ''
      }
      
    },
     /**
     * @description: 上移
     * @param {*}
     * @return {*}
     */
    MoveupHandel(scope){
      moveUp(scope.row.id,this.paramsType).then(res=>{
        if(res.code == 0){
          this.init(this.paramsType)
          this.$message({
            type:'success',
            message:res.message
          })
        }else{
          this.$message({
            type:'error',
            message:res.message
          })
        }
      })
    },
    /**
     * @description: 下移
     * @param {*}
     * @return {*}
     */
    MovedownHandel(scope){
      moveDown(scope.row.id,this.paramsType).then(res=>{
        if(res.code == 0){
          this.init(this.paramsType)
          this.$message({
            type:'success',
            message:res.message
          })
        }else{
          this.$message({
            type:'error',
            message:res.message
          })
        }
      })
    },
    
    /**
     * @description:
     * @event:
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      this.formInline = this.$options.data().formInline
      this.init(this.paramsType)
    },
    /**
     * @description:查询
     * @event:
     * @param {*}
     * @return {*}
     */
    queryHandel() {
      this.formInline.platformId = this.formInline.hospitalId ;
      if ( Array.isArray(this.formInline.time) && this.formInline.time.length > 1) {
        this.formInline.updateEndTime =  this.$machiningTime(this.formInline.time[1])
        this.formInline.updateStartTime = this.formInline.time[0]
      } else {
        this.formInline.updateEndTime = ''
        this.formInline.updateStartTime = ''
      }
      this.init(this.paramsType)
    },
    /**
     * @description: 获取开放科室列表
     * @param {}
     * @return {*}
     */
    init(payload) {
      getdepartment(this.formInline , payload).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data
        }
      })
    },

    //启用停用按钮
    disabledHandel(scope) {
      const scopeItem = scope.row;
      axios.put(`/admin/${this.paramsType}-department`, {
        id: scopeItem.id,
        disabled: !scopeItem.disabled,
      }).then(res => {
        if (res.data.code == 0) {
          this.$message.success('修改成功')
          this.init(this.paramsType)
        }
      })
    },
    //删除科室
    hosdel(row) {
      if (row.children && row.children.length) return this.$message.error('请先删除子科室')
      this.$confirm('是否确认删除该条数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'message-confirm-style'
      }).then(() => {
        deleteDepartment(row.id).then((resp) => {
          if (resp.data) {
            this.$message.success('删除成功')
            this.init(this.paramsType)
          }
        })
      })
    },
    // 新增科室
    addDept(id, type, row,types) {
      this.currentItemId = id
      for (let x in this.createForm) {
        this.createForm[x] = ''
      }
      if(types == 2){
        this.flagcopy = true;
        this.createForm.hospitalId = row.hospitalId || row.platformId
      }
      if (types == 3) {//下级科室
        this.flag = true
        this.childrenData = row
        this.createForm.hospitalId = row.hospitalId || row.platformId
      }
      this.isShowAdd = true
    },
    confirmAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let temp = _.cloneDeep(this.createForm)
          temp.parentId = this.currentItemId
          temp.platformId = temp.hospitalId
          // temp.standardDepartmentId = temp.cityList;
          // return
          postDepartment(temp,this.paramsType).then((resp) => {
            if (resp.data) {
              this.$message.success('创建成功')
              this.createForm = this.$options.data().createForm
              this.isShowAdd = false
              this.init(this.paramsType)
            }
          })
        } else {
          return false
        }
      })
    },
    cancelAdd() {
      for (let x in this.createForm) {
        this.createForm[x] = ''
      }
      this.isShowAdd = false
    },
    // 编辑科室
    showDetail(row) {
      getDepartmentDetail(row.id,this.paramsType).then((resp) => {
        this.editsonlist = resp.data
        this.editsonlist.hospitalId = resp.data.platformId || resp.data.hospitalId
      })
      this.edit = true
      this.drawer = true
    },
    setStrDept() {
      this.isShowDept = true
    },
    confirmDept(obj) {
      this.editsonlist.standardDepartmentId = obj.id
      this.editsonlist.standardDepartmentName = obj.name
      this.isShowDept = false
    },
    sonedit() {

      this.$refs['editlist'].validate((valid) => {
        if (valid) {
          axios.put(`/admin/${this.paramsType}-department`, {
            id: this.editsonlist.id,
            description: this.editsonlist.description,
            disabled: this.editsonlist.disabled,
            hospitalId: this.editsonlist.hospitalId,
            platformId:this.editsonlist.hospitalId,
            name: this.editsonlist.name,
            standardDepartmentId: this.editsonlist.standardDepartmentId,
          }).then((resp) => {
            let data = resp.data
            if (data.success) {
              this.$message.success('编辑成功')
              this.init(this.paramsType)
            }
            this.drawer = false
          })
        } 
      })
    },
  }
}
</script>



<style lang="less" scoped>
.tablessp {
  /deep/ thead tr .el-checkbox__input{
    display: none;
  }
}
.footer{
        display: flex;
        justify-content: space-around;
        p{
            display: flex;
            span{
                display: block;
                margin-left: 20px;
            }
        }
    }
 .slot-footer{
        display: flex;
        justify-content: center;
        position: relative;
        padding-bottom: 24px;
        .btn{
            position: absolute;
            right: 0;
            top: 0;
        }
    }
.organization {
  .organization-top {
    background-color: #fff;
    width: 100%;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0px 15px;
    .organization-top-person {
      font-weight: bolder;
      margin-right: 15px;
      flex: 1;
      line-height: 90px;
    }
    .organization-top-search {
      width: 250px;
      line-height: 90px;
      /deep/.el-input__inner {
        border-radius: 20px;
      }
    }
    .organization-top-btn {
      /deep/.el-dropdown {
        margin-left: 20px;
        .el-button {
          border-radius: 20px;
        }
      }
    }
    .organization-top-date {
      margin-left: 35px;
      line-height: 90px;
      .el-date-editor {
        border-radius: 20px;
        border-color: skyblue;
      }
    }
  }
  .organization-content {
    width: 100%;
    background-color: #fff;
    border-radius: 15px;
    box-sizing: border-box;
    .organization-table {
      /deep/.el-button {
        border: none;
      }
    }
    .organization-content-title {
      display: flex;
      justify-content: space-between;
      line-height: 53px;
      border-bottom: 1px solid #ccc;
      margin-bottom: 10px;
      margin-right: 20px;
    }
    /deep/.el-table th > .cell {
      text-align: center;
    }
    /deep/.el-table .cell {
      text-align: center;
    }
    .operation {
      display: flex;
      flex-wrap: nowrap;
      .el-button {
        border: none;
        color: skyblue;
        background: #fff;
        padding: 0;
      }
    }
    .cardpage {
      margin-top: 40px;
      text-align: right;
    }
  }
  .organization-right {
    /deep/.el-drawer__header {
      font-size: 18px;
      font-weight: bolder;
      color: skyblue;
    }
  }
  .department-add {
    .title {
      font-size: 26px;
      text-align: center;
      margin-bottom: 15px;
    }
    /deep/.el-form-item__label {
      width: 100%;
    }
    /deep/ .el-drawer__body {
      padding: 16px;
      overflow: auto;
    }
    .marform {
      margin-top: 20px;
    }
    .department-bottom {
      display: flex;
      justify-content: space-between;
      margin-left: 30px;
      margin-bottom: 30px;
      margin-right: 60px;
      margin-top: 40px;
    }
    .btn-group {
      text-align: center;
      padding: 20px 0;
    }
    .form-wrap {
      span {
        margin-right: 20px;
      }
    }
  }
  .parent-wrap {
    .name,
    .child-name {
      line-height: 24px;
      cursor: pointer;
    }
    .name:hover,
    .child-name:hover {
      color: #409eff;
    }
    .child-name {
      padding-left: 20px;
    }
    .children {
      margin-left: 10px;
      border-left: 1px solid #999;
    }
  }
}
</style>
